import gql from "graphql-tag";

// Since many mutations update the "updates" array, and it has a lot of subfields and you always want at least the
// string version of all of them, this lets you grab the full set in one line. You should remember to also include
// the report ID (but that's not included here as it isn't part of the activity feed really and you should be doing it anyway)
export const activityFeed = gql`
  fragment activityFeed on Report {
    updates {
      id
      activityType
      author {
        id
        name
      }
      createdAt
      data {
        body
        url
        redacted
        userName
        teamName
        update {
          id
          activityType
          authorName
          createdAt
        }
        answer {
          questionName
          question {
            id
          }
        }
        outcomeNames
        riskAssessment {
          id
        }
        repeatedName {
          id
          ignored
          partlyIgnored
          name {
            id
            name
            ignored
          }
        }
        questionId
        reclassifiedAnswers {
          optionId
          optionText
          answerId
          newStatus
        }
        linkedReport {
          id
          key
        }
      }
    }
  }
`;

export const siteFields = gql`
  fragment siteFields on Site {
    id
    name
    urls {
      id
      host
      status
      cnameTarget
      certificateCnameOrigin
      certificateCnameTarget
      certificateValidUntil
    }
    language
    noticeText
    noticeVisible
    noticeStartDate
    noticeEndDate
    slaText
    slaVisible
    hiddenFromSearchEngines
    hideReportPage
    branding {
      heroLogo
      contactEmail
      contactOrgName
      contactStreet1
      contactStreet2
      contactStreet3
      contactLocality
      contactRegion
      contactPostcode
      contactCountry
      contactMapUrl
      feedbackTitle
      feedbackText
      feedbackLink
      facebook
      twitter
      youtube
      instagram
      linkedin
      footerLinks {
        name
        link
      }
      headerLinks {
        name
        link
      }
      homepageHero {
        type
        titleImage
        text
        image
        backgroundColour
        foregroundColour
        bubbleLeft
        bubbleRight
      }
      campaignsHero {
        type
        text
        image
        backgroundColour
        foregroundColour
        bubbleLeft
        bubbleRight
      }
      reportHero {
        type
        text
        image
        backgroundColour
        foregroundColour
        bubbleLeft
        bubbleRight
      }
      primaryColour
      primaryColourInverse
      fontSheetUrl
      primaryFont
      secondaryFont
      googleTagId
    }
  }
`;

export const categoryFields = gql`
  fragment categoryFields on Category {
    id
    name
    imageUrl
    articles {
      id
    }
    slug
  }
`;
export const documentFields = gql`
  fragment documentFields on Document {
    id
    name
    documentType
    slug
    currentDraft {
      id
      body
    }
    published {
      publishedVersion {
        id
      }
      publicationMode
      path
    }
    externalLinkUrl
  }
`;

export const campaignFields = gql`
  fragment campaignFields on Campaign {
    id
    name
    subtitle
    imageUrl
    published
    contentType
    body
    externalLinkUrl
    slug
  }
`;

export const riskAssessmentDetails = gql`
  fragment riskAssessmentDetails on RiskAssessment {
    id
    author {
      id
      name
    }
    formVersion
    createdAt
    draft
    answers {
      questionId
      optionId
      freeText
      riskLevel
    }
  }
`;

export const questionFields = gql`
  fragment questionFields on Question {
    id
    title
    shortTitle
    titleTranslations {
      text
    }
    contextAwareTitles {
      title
      titleTranslations {
        text
      }
    }
    analyticsCode
    type
    optionGroups {
      id
      groupName
      groupNameTranslations {
        text
      }
      options {
        id
        value
        valueTranslations {
          text
        }
      }
    }
    deletedOptions {
      id
      value
      groupId
    }
    deletedOptionGroups {
      id
      groupName
    }
    answersHidden
    required
  }
`;
